import { Typography } from "@mui/material";
import type { FC } from "react";

export const NotSet: FC = () => {
  return <Typography variant="body2">Not set</Typography>;
};
